export const messages = {
  en: {
    resourceStoreSpecificationManage: {
      queryConditions: 'Query Conditions',
      more: 'More',
      hide: 'Hide',
      selectItemType: 'Select Item Type',
      selectSubCategory: 'Select Sub-category',
      specNamePlaceholder: 'Enter Specification Name',
      specIdPlaceholder: 'Enter Specification ID',
      query: 'Query',
      reset: 'Reset',
      itemSpecifications: 'Item Specifications',
      add: 'Add',
      specId: 'Specification ID',
      typeName: 'Type Name',
      specName: 'Specification Name',
      description: 'Description',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      addSpec: 'Add Specification',
      itemType: 'Item Type',
      descriptionPlaceholder: 'Description (optional)',
      save: 'Save',
      cancel: 'Cancel',
      editItemSpec: 'Edit Item Specification',
      confirmDeleteTitle: 'Confirm Operation',
      confirmDeleteMsg: 'Confirm to delete this specification?',
      cancelDelete: 'Cancel',
      confirmDelete: 'Confirm Delete'
    }
  },
  zh: {
    resourceStoreSpecificationManage: {
      queryConditions: '查询条件',
      more: '更多',
      hide: '隐藏',
      selectItemType: '请选择物品类型',
      selectSubCategory: '请选择二级分类',
      specNamePlaceholder: '请输入规格名称',
      specIdPlaceholder: '请输入规格编号',
      query: '查询',
      reset: '重置',
      itemSpecifications: '物品规格',
      add: '添加',
      specId: '规格编号',
      typeName: '类型名称',
      specName: '规格名称',
      description: '描述',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      addSpec: '添加规格',
      itemType: '商品类型',
      descriptionPlaceholder: '选填，请填写描述',
      save: '保存',
      cancel: '取消',
      editItemSpec: '修改物品规格',
      confirmDeleteTitle: '请确认您的操作',
      confirmDeleteMsg: '确定删除物品规格',
      cancelDelete: '点错了',
confirmDelete: '确认删除'
    }
  },
  'zh-TW': {
    resourceStoreSpecificationManage: {
      queryConditions: '查詢條件',
      more: '更多',
      hide: '隱藏',
      selectItemType: '請選擇物品類型',
      selectSubCategory: '請選擇二級分類',
      specNamePlaceholder: '請輸入規格名稱',
      specIdPlaceholder: '請輸入規格編號',
      query: '查詢',
      reset: '重置',
      itemSpecifications: '物品規格',
      add: '添加',
      specId: '規格編號',
      typeName: '類型名稱',
      specName: '規格名稱',
      description: '描述',
      operation: '操作',
      edit: '修改',
      delete: '刪除',
      addSpec: '添加規格',
      itemType: '商品類型',
      descriptionPlaceholder: '選填，請填寫描述',
      save: '保存',
      cancel: '取消',
      editItemSpec: '修改物品規格',
      confirmDeleteTitle: '請確認您的操作',
      confirmDeleteMsg: '確定刪除物品規格',
      cancelDelete: '點錯了',
      confirmDelete: '確認刪除'
    }
  }
}